/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiEvent} from "./UiEvent";
import {UiCommand} from "./UiCommand";
import {UiSubEvent} from "./UiSubEvent";
import {UiSubCommand} from "./UiSubCommand";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiFieldConfig} from "./UiFieldConfig";
import {UiTextInputHandlingFieldConfig} from "./UiTextInputHandlingFieldConfig";
import {UiToolbarVisibilityMode} from "./UiToolbarVisibilityMode";
import {UiFieldSubCommandHandler} from "./UiFieldConfig";
import {UiTextInputHandlingFieldSubEventSource} from "./UiTextInputHandlingFieldConfig";


export interface UiRichTextEditorConfig extends UiFieldConfig, UiTextInputHandlingFieldConfig {
	_type?: string;
	uploadUrl?: string;
	maxImageFileSizeInBytes?: number;
	toolbarVisibilityMode?: UiToolbarVisibilityMode;
	minHeight?: number;
	maxHeight?: number
}

export interface UiRichTextEditorSubCommandHandler extends UiFieldSubCommandHandler {
	setMinHeight(minHeight: number): void;
	setMaxHeight(maxHeight: number): void;
	setUploadUrl(uploadUrl: string): void;
	setMaxImageFileSizeInBytes(maxImageFileSizeInBytes: number): void;
	setUploadedImageUrl(fileUuid: string, url: string): void;
	setToolbarVisibilityMode(toolbarVisibilityMode: UiToolbarVisibilityMode): void;
}

export interface UiRichTextEditorSubEventSource extends UiTextInputHandlingFieldSubEventSource {
	onImageUploadTooLarge: TeamAppsEvent<UiRichTextEditor_ImageUploadTooLargeSubEvent>;
	onImageUploadStarted: TeamAppsEvent<UiRichTextEditor_ImageUploadStartedSubEvent>;
	onImageUploadSuccessful: TeamAppsEvent<UiRichTextEditor_ImageUploadSuccessfulSubEvent>;
	onImageUploadFailed: TeamAppsEvent<UiRichTextEditor_ImageUploadFailedSubEvent>;
}

export interface UiRichTextEditor_ImageUploadTooLargeSubEvent extends UiSubEvent {
	_type: "UiRichTextEditor.imageUploadTooLarge";
	redundancyKey?: string;
	fileName: string;
	mimeType: string;
	sizeInBytes: number
}

export interface UiRichTextEditor_ImageUploadStartedSubEvent extends UiSubEvent {
	_type: "UiRichTextEditor.imageUploadStarted";
	redundancyKey?: string;
	fileName: string;
	mimeType: string;
	sizeInBytes: number;
	incompleteUploadsCount: number
}

export interface UiRichTextEditor_ImageUploadSuccessfulSubEvent extends UiSubEvent {
	_type: "UiRichTextEditor.imageUploadSuccessful";
	redundancyKey?: string;
	fileUuid: string;
	name: string;
	mimeType: string;
	sizeInBytes: number;
	incompleteUploadsCount: number
}

export interface UiRichTextEditor_ImageUploadFailedSubEvent extends UiSubEvent {
	_type: "UiRichTextEditor.imageUploadFailed";
	redundancyKey?: string;
	name: string;
	mimeType: string;
	sizeInBytes: number;
	incompleteUploadsCount: number
}
